import PropTypes from 'prop-types'
import React from 'react'

import CommitteeWardMap from './CommitteeWardMap'
import MemberHighlight from './MemberHighlight'
import MemberList from './MemberList'
import NextMeeting from './NextMeeting'
import Text from './Text'

import './Committee.css'


const DEFAULT_MAP_WIDTH = 400


const Committee = ({
  committee,
  members,
  wards,
  width,
  highlightWard,
  onClickWard,
  emailSubjectTpl,
  emailBodyTpl
}) => {
  if (!committee) {
    return false;
  }

  const memberToHighlight = members.find(member => member.ward === highlightWard)

  const memberHighlight = (
    memberToHighlight ?
    <MemberHighlight
      member={memberToHighlight}
      emailSubjectTpl={emailSubjectTpl}
      emailBodyTpl={emailBodyTpl} /> :
    false
  )

  return (
    <div className="Committee">
      <h3 className="Committee-name">{committee.name}</h3>
      <NextMeeting date_time={committee.next_meeting_date_time}
        loc={committee.next_meeting_location}
        address={committee.next_meeting_address} />
      <Text className="Committee-description">{committee.description}</Text>
      {memberHighlight}
      <CommitteeWardMap
        wards={wards}
        members={members}
        width={Math.min(width, DEFAULT_MAP_WIDTH)}
        highlightWard={highlightWard}
        onClickWard={onClickWard} />
      <MemberList members={members} highlightWard={highlightWard} onClickWard={onClickWard} />
    </div>
  )
}

Committee.propTypes = {
  committee: PropTypes.object,
  members: PropTypes.array,
  wards: PropTypes.object,
  width: PropTypes.number,
  highlightWard: PropTypes.number,
  onClickWard: PropTypes.func,
  emailSubjectTpl: PropTypes.func,
  emailBodyTpl: PropTypes.func
}

export default Committee



// WEBPACK FOOTER //
// ./src/Committee.js